var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSendEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 20,
    viewBox: "0 0 39 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1C2154",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.514 5.178l5.57 4.978.013.012c.023.02.048.04.073.057l.04.026c.024.016.051.03.079.044l.029.014c.026.012.053.022.08.031l.047.015c.025.007.05.013.077.018l.039.007c.049.007.092.01.135.01.175.013.35-.023.505-.104l8.792-4.829c.024.262-.014.528-.116.78l-3.072 8.107c-.38.943-1.294 1.589-2.343 1.655H15.75c-.552.014-1.075-.236-1.397-.667-.315-.47-.375-1.058-.162-1.578l3.073-8.106c.067-.167.152-.324.25-.47zM31.346 4c.174-.003.345.021.507.07l-8.03 4.387-4.857-4.34c.213-.065.437-.105.666-.117h11.714zm-19.228 8.766h-4c-.498 0-.902-.389-.902-.867 0-.48.404-.867.901-.867h4c.499 0 .902.388.902.867 0 .478-.403.867-.901.867zm1.225-3.234h-4c-.498 0-.901-.389-.901-.867 0-.48.403-.867.9-.867h4.001c.498 0 .901.388.901.867 0 .478-.403.867-.9.867zm-2.261 6.467H6.9C6.403 16 6 15.611 6 15.132c0-.478.403-.867.901-.867h4.18c.498 0 .902.389.902.867 0 .48-.404.867-.901.867z",
    transform: "translate(-545 -952) translate(543 950) translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendEmail);
export default __webpack_public_path__ + "static/media/icon-send-email.465dfc2d.svg";
export { ForwardRef as ReactComponent };